


















































































































































import {
  FooterActionDispatcher,
  OpportunityIcon,
  OpportunityInfo,
  OpportunityTags,
} from '@/components/opportunities';

import Vue from 'vue';
import { OpportunityDraft } from '../../models/opportunities';
import { Actions } from '../../store';

export default Vue.extend({
  name: 'OpportunityDraftDetailsView',
  components: {
    FooterActionDispatcher,
    OpportunityIcon,
    OpportunityInfo,
    OpportunityTags,
  },
  data() {
    return {
      loader: {
        isOpportunityDraftDetailsPending: true,
      },
    };
  },
  created() {
    this.fetchOpportunityDraft();
  },
  computed: {
    opportunityDraft(): OpportunityDraft {
      return this.$store.state.opportunities.drafts.current;
    },
  },
  methods: {
    async fetchOpportunityDraft() {
      this.loader.isOpportunityDraftDetailsPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.drafts.fetchCurrent, this.$route.params.id);
      } finally {
        this.loader.isOpportunityDraftDetailsPending = false;
      }
    },
  },
});
